import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { withRouter } from "react-router";
import { dealGet, dealAnalysisGetDealMetrics, getDealPropertyProjections, dealAnalysisGetClosedLoans } from './dealAnalysis.store';
import { mapCompanySelector, mapGuestPermissions } from "store/state/auth";
import SearchIcon from '@material-ui/icons/Search';
import { AnalysisTile, mapMetricFromList, DEAL_METRICS, LOAN_TYPES, LOAN_SENIORITY_TYPES, GUEST_PERMISSIONS } from '@loanbossinc/component-library';
import { CardPageLayout } from "component-lib/CardPageLayout";
import numberFormatter from "utils/numberFormatter";
import { GenericHeroCard } from "component-lib/";
import WhatIfModule from "./whatIfModule";
import { DealMetricTable } from "./dealMetricTable";
import ModalForm from '../../modals/RefiCashOutCalculatorModal/ModalForm';
import PrepaymentCalculatorModel from "modals/PrepaymentCalculatorModel/PrepaymentCalculatorModel";
import SupplementalCalculatorModal from "modals/SupplementalCalculatorModal/SupplementalCalculatorModal";
import WhatIfModal from "modals/WhatIfCalculatorModal/WhatIfModal";
import { StyledTitle, StyledBodyWrapper, StyledInputText, StyledAnalysisWrapper, } from './dealAnalysis.style';
import { REFI_CASHOUT_CALCULATOR_MODAL, PREPAYMENT_CALCULATOR_MODAL, SUPPLEMENTAL_CALCULATOR_MODAL, WHAT_IF_MODAL } from "./dealAnalysis.constants";
import { ROUTE_REFI_PROCEEDS_ANALYSIS_UNSUPERVISED, ROUTE_REFI_PROCEEDS_ANALYSIS_SUPERVISED } from 'constants/routes';
import { getMetricTitle, isInGuestMetricList, shouldUpdateFilter } from './dealAnalysis.util';
import PriceCheck from 'lib/images/price_check.svg';

class DealAnalysis extends Component {
  state = {
    searchText: '',
    filteredMetrics: [],
    openModal: { name: null, data: null },
    dealPrepaymentAnalysis: {},
    pageChange: true,
    loanSpreadId: null
  };

  componentDidMount() {
    const { dealId } = this.props.match.params;
    this.props.dealGet({ dealId });
    this.props.dealAnalysisGetDealMetrics({ dealId });
    this.props.dealAnalysisGetClosedLoans({ dealId });
    this.props.getDealPropertyProjections({ dealId });
  }

  getLoanProceedAssumptionWithLoanSpreadId(lpas) {
    const lpaWithLoanSpread = lpas?.find((lpa) => lpa?.loanSpreadId);
    if (lpaWithLoanSpread) {
      return lpaWithLoanSpread.loanSpreadId;
    }
    return '';
  }

  componentDidUpdate(prevProps, prevState) {
    if (shouldUpdateFilter(prevProps, prevState, this.props, this.state)) {
      this.updateFilter();
    }
    const dealId = this.props?.deal?.id;
    const prevDealId = prevProps?.deal?.id;
    const dealPrepaymentAnalysis = this.props?.dealPrepaymentAnalysis;
    const prevDealPrepaymentAnalysis = prevProps?.dealPrepaymentAnalysis;
    const prevLoanSpreadId = this.getLoanProceedAssumptionWithLoanSpreadId(this.props?.deal?.loanProceedAssumptions);

    if (this.state.loanSpreadId !== prevLoanSpreadId) {
      this.setState({ loanSpreadId: this.getLoanProceedAssumptionWithLoanSpreadId(this.props?.deal?.loanProceedAssumptions) });
    }

    if (dealId !== prevDealId) {
      this.setState({ dealPrepaymentAnalysis: {}, pageChange: true });
    }

    if (dealId === dealPrepaymentAnalysis?.dealId && dealPrepaymentAnalysis !== prevDealPrepaymentAnalysis && this.state.pageChange) {
      this.setState({ dealPrepaymentAnalysis, pageChange: false });
    }
  }

  handleMetricSearchChange = (event) => {
    const searchText = event.target.value ? event.target.value : '';
    this.setState({
      searchText
    });
  }

  sendToRefi = () => {
    const { dealId } = this.props.match.params;
    const { deal, history } = this.props;
    history.push(deal?.hasFavoriteLoanProceeds ?
      ROUTE_REFI_PROCEEDS_ANALYSIS_SUPERVISED(dealId, this.state.loanSpreadId) :
      ROUTE_REFI_PROCEEDS_ANALYSIS_UNSUPERVISED(dealId),
      { from: history.location.pathname });
  }

  updateFilter = () => {
    const { deal, authentication, guestPermission, daGuestPermission } = this.props;
    const { searchText, filteredMetrics } = this.state;
    const normalizedSearchText = (searchText || '').toLowerCase();

    if (!deal || !deal.dealMetrics) return [];
    const metrics = (!searchText || searchText === '')
      ? deal.dealMetrics
      : deal.dealMetrics.filter(metric => {
        if (!metric || !metric.screen_element || !metric.screen_element.title) return false;
        const title = (metric.screen_element.title || '').toLowerCase();
        return title.includes(normalizedSearchText);
      });

    let _filteredMetrics = [];
    if (!authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioMetricsPermissionId === GUEST_PERMISSIONS.FULL)) {
      _filteredMetrics = metrics.sort((a, b) => getMetricTitle(a).localeCompare(getMetricTitle(b)));
    } else if (guestPermission && daGuestPermission && daGuestPermission.length > 0) {
      _filteredMetrics = metrics.filter(x => isInGuestMetricList(daGuestPermission[0].companyMetrics, x.metricId)).sort((a, b) => getMetricTitle(a).localeCompare(getMetricTitle(b)));
    }
    if (_filteredMetrics && _filteredMetrics.length > 0)
      this.setState({ filteredMetrics: _filteredMetrics });
    else if (filteredMetrics.length > 0 && _filteredMetrics.length === 0)
      this.setState({ filteredMetrics: [] });
  }

  renderMetrics = () => {
    const { deal } = this.props;
    const { searchText, filteredMetrics } = this.state;

    if (!deal) return null;

    return (
      <div style={{ display: 'flex', flexDirection: 'column' }}>
        <StyledTitle>Metrics</StyledTitle>

        <StyledInputText
          type="search"
          variant="outlined"
          borderRadius={8}
          placeholder="Search for a metric"
          onChange={this.handleMetricSearchChange}
          value={searchText}
          InputProps={{ startAdornment: <SearchIcon /> }}
        />

        <DealMetricTable
          className="deal-metric-table"
          metrics={filteredMetrics} />
      </div>
    );
  }

  closeModal = () => this.setState({ openModal: { name: null, data: null } });

  openModal = (name, data = null) => this.setState({ openModal: { name, data } });

  isModalOpen = (modalName) => {
    const { openModal } = this.state;
    return openModal.name === modalName;
  }

  hasFreddieLoan = () => {
    if (!this.props.closedLoans) return false;

    let result = false;
    this.props.closedLoans.forEach(x => {
      if (x.loanTypeId === LOAN_TYPES.FREDDIE_MAC && x.loanSeniorityId === LOAN_SENIORITY_TYPES.SENIOR) {
        result = true;
      }
    })
    return result;
  }

  getTileData = () => {
    const { deal, authentication, guestPermission } = this.props;
    const { dealPrepaymentAnalysis } = this.state;
    if (!deal || !deal.dealMetrics) return null;
    const enableSupplementalProceeds = this.hasFreddieLoan();
    const canCalculate = !authentication.isGuest || (authentication.isGuest && guestPermission && guestPermission.portfolioProjections);

    let prepaymentCost = null;
    if (dealPrepaymentAnalysis && dealPrepaymentAnalysis.PrepaymentResults && dealPrepaymentAnalysis.PrepaymentResults.length > 0) {
      const overview = dealPrepaymentAnalysis.PrepaymentResults.filter(x => x.label === "Overview");
      if (overview && overview.length > 0)
        prepaymentCost = overview[0].prepaymentCost;
    }
    return {
      prepayment: {
        title: "Prepayment"
        , metricValue: prepaymentCost === null ? "--" : numberFormatter.formatMoney(prepaymentCost, 0)
        , iconName: "report"
        , buttonLabel: !dealPrepaymentAnalysis ? "Processing" : "Calculate"
        , onClick: () => this.openModal(PREPAYMENT_CALCULATOR_MODAL)
        , buttonDisabled: !dealPrepaymentAnalysis
      }
      , refiProceeds: {
        title: "Refi Cashout"
        , metricValue: mapMetricFromList(DEAL_METRICS.REFI_CASH_OUT, deal.dealMetrics)
        , iconName: "local_atm"
        , buttonLabel: "Calculate"
        , onClick: () => this.openModal(REFI_CASHOUT_CALCULATOR_MODAL)
        , buttonDisabled: !canCalculate //|| !this.props?.deal?.hasFavoriteLoanProceeds //Uncomment this when the calculator is ready
        , disabledText: 'Select a preferred refinancing scenario to calculate.'
      }
      , supplementalProceeds: {
        title: "Supplemental Proceeds"
        , metricValue: mapMetricFromList(DEAL_METRICS.SUPPLEMENTAL_LOAN_PROCEEDS, deal.dealMetrics)
        , iconName: "payments"
        , buttonLabel: "Calculate"
        , onClick: () => this.openModal(SUPPLEMENTAL_CALCULATOR_MODAL)
        , buttonDisabled: !enableSupplementalProceeds && !canCalculate
      }
    }
  }

  hasMetricPermission = (companyMetrics, metricId) => {
    if (!companyMetrics || companyMetrics.length === 0) return false;
    return companyMetrics.some(item => item.screenElementId === metricId);
  }

  renderAnalysis = () => {
    const { authentication, guestPermission } = this.props;
    const tileData = this.getTileData();
    if (!tileData) return null;
    const isNotGuest = authentication && !authentication.isGuest;
    const guestHasMetricPermission = (authentication.isGuest && (guestPermission && guestPermission.portfolioMetricsPermissionId));
    if (isNotGuest || guestHasMetricPermission) {
      const { dealId } = this.props.match.params;

      return (
        <StyledAnalysisWrapper>
          <StyledTitle>Analysis</StyledTitle>
          {isNotGuest &&
            <>
              <WhatIfModule
                title='Refinance Analysis'
                subtitle='Evaluate refinance scenarios'
                onClick={() => this.sendToRefi()}
                icon={() => <img className='svg' src={PriceCheck} alt='price_check' width='48' height='48' />}
              />
              <WhatIfModule
                title='What If Calculator'
                subtitle='Plan, budget, and forecast'
                onClick={() => this.openModal(WHAT_IF_MODAL)}
                iconName='help_outline' />
            </>
          }
          <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'center' }}>
            {<AnalysisTile className="tile" {...tileData.prepayment} />}
            {this.canViewAnalysisTile(isNotGuest, guestHasMetricPermission, DEAL_METRICS.REFI_PROCEEDS) && <AnalysisTile className="tile" {...tileData.refiProceeds} />}
            {this.canViewAnalysisTile(isNotGuest, guestHasMetricPermission, DEAL_METRICS.SUPPLEMENTAL_LOAN_PROCEEDS) && <AnalysisTile className="tile" {...tileData.supplementalProceeds} />}
          </div>
        </StyledAnalysisWrapper >
      )
    }
    return null;
  }

  canViewAnalysisTile = (isNotGuest, guestHasMetricPermission, metric) => {
    const { guestPermission, daGuestPermission } = this.props;
    const hasFullMetricPermission = (guestPermission && guestPermission.portfolioMetricsPermissionId === GUEST_PERMISSIONS.FULL);
    const hasRestrictedMetricPermission = (guestPermission && guestPermission.portfolioMetricsPermissionId === GUEST_PERMISSIONS.RESTRICTED);
    return (
      isNotGuest ||
      (guestHasMetricPermission &&
        (hasFullMetricPermission ||
          (hasRestrictedMetricPermission &&
            daGuestPermission &&
            daGuestPermission.length > 0 &&
            this.hasMetricPermission(daGuestPermission[0].companyMetrics, metric)
          )
        )
      )
    );
  }
  render() {
    const { dealId } = this.props.match.params;
    const { deal, currentdeal, history } = this.props;
    if (!deal) return null;

    return (
      <>
        <CardPageLayout {...this.props}
          isReversed
          bannerImageUrl={currentdeal && currentdeal.imageLarge}
          cardComponent={<GenericHeroCard {...{ ...this.props, deal: currentdeal, title: deal.name, backLabel: "Deal Summary", onBackButtonClick: () => history.push(`/deal/${dealId}`) }} />}
          bodyComponent={
            <StyledBodyWrapper>
              {this.renderAnalysis()}
              {this.renderMetrics()}
            </StyledBodyWrapper>
          }
        />

        <ModalForm
          scope="deal"
          dealId={dealId}
          isOpen={this.isModalOpen(REFI_CASHOUT_CALCULATOR_MODAL)}
          handleClose={this.closeModal}
        />

        <PrepaymentCalculatorModel
          dealId={dealId}
          isOpen={this.isModalOpen(PREPAYMENT_CALCULATOR_MODAL)}
          closeModal={this.closeModal}
        />

        <SupplementalCalculatorModal
          dealId={dealId}
          isOpen={this.isModalOpen(SUPPLEMENTAL_CALCULATOR_MODAL)}
          handleClose={this.closeModal}
          closedLoans={this.props.closedLoans}
          dealPropertyProjections={this.props.dealPropertyProjections}
        />

        <WhatIfModal
          scope="deal"
          dealId={dealId}
          dealMetrics={deal.dealMetrics}
          isOpen={this.isModalOpen(WHAT_IF_MODAL)}
          handleClose={this.closeModal}
        />
      </>
    );
  }
}

const mapStateToProps = ({ dealAnalysis, authentication, prepaymentCalculator }) => ({
  ...dealAnalysis
  , daGuestPermission: dealAnalysis.guestPermission
  , guestPermission: mapGuestPermissions(authentication, dealAnalysis.guestPermission)
  , ...prepaymentCalculator
  , company: mapCompanySelector(authentication)
  , authentication
});

export default compose(
  withRouter
  , connect(mapStateToProps, {
    dealGet
    , dealAnalysisGetDealMetrics
    , getDealPropertyProjections
    , dealAnalysisGetClosedLoans
  })
)(DealAnalysis);
